// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"42dbb443","547":"fdbdfe9b","832":"d8aa5af4","885":"4d10d121","896":"46c331c1"}[chunkId] + ".chunk.js";
};